import { Component, Input } from "@angular/core";
import { ObservacaoEstudoDialog } from "./observacao-estudo-dialog";
import { MatDialog } from "@angular/material";
import { ObservacaoEstudo } from "./observacao-estudo";

@Component({
  templateUrl: "./observacao-estudo-button.component.html",
  selector: "observacao-estudo-button"
})
export class ObservacaoEstudoButtonComponent {
  @Input()  idEstudo: number;
  @Input()  mostrarSomenteIcone: boolean = false;
  public resumo: ObservacaoEstudo;
  public isLoading: boolean;

  constructor(public dialog: MatDialog) {}

  public abrir() {
    let dialogRef = this.dialog.open(ObservacaoEstudoDialog, {
      width: "800px",
      height: "700px",
      data: this.idEstudo
    });
    let resultado: any;
    dialogRef.afterClosed().subscribe(result => {});
  }
}
